import { generateId, generateWordSlug } from "@@/utilities/generate-id";

const generateRequestId = () =>
    `${generateWordSlug()}_${generateId({ length: 6 })}`;

export {
    generateRequestId as generateComboId,
    generateRequestId,
    generateRequestId as generateSessionId,
};
